import { BaseModel } from "@blue-chip/core";

export default class PermissionGroup extends BaseModel {
  static plural = "permissionGroups";
}
